import { render, staticRenderFns } from "./vcolumnarChart.vue?vue&type=template&id=2af3e0ed&scoped=true"
import script from "./vcolumnarChart.vue?vue&type=script&lang=js"
export * from "./vcolumnarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af3e0ed",
  null
  
)

export default component.exports